<template>
    <v-container class="fill-screen d-flex justify-center align-center">
        <v-row class="justify-center align-center ">
            <v-col cols="auto">
                <PasswordResetCard/>
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
  
import PasswordResetCard from '../components/PasswordResetCard.vue';
  
export default {
    components: {
        PasswordResetCard
    },
    data(){
        return{}
    },
}
</script>

<style scoped>
.fill-screen {
  height: 100vh;   
  padding: 0;           
}
</style>